import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { IEnvironment } from '../../models/environment.model';
import { IHttpPagedResponse } from '../../../../public-api';
import { ILocale } from '../../models/locale.model';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private readonly environment: IEnvironment;
  private baseUrl = '';
  private languageChangedSubject = new BehaviorSubject<boolean>(false);
  languageChanged$ = this.languageChangedSubject.asObservable();

  loadingTranslations: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  supportedLocalesSubject: BehaviorSubject<ILocale[]> = new BehaviorSubject<
    ILocale[]
  >([]);
  supportedLocales$ = this.supportedLocalesSubject.asObservable();
  activeLocaleSubject: BehaviorSubject<ILocale> = new BehaviorSubject<ILocale>(
    {} as ILocale
  );
  activeLocale$ = this.activeLocaleSubject.asObservable();

  translationsLoadedBefore = false;

  constructor(
    private http: HttpClient,
    @Inject('environment') environment: IEnvironment
  ) {
    this.environment = environment;
    this.baseUrl = environment.apiGatewayBaseUrl + '/admin/v1';
  }

  getSupportedLocales(): Observable<IHttpPagedResponse<ILocale>> {
    return this.http.get<IHttpPagedResponse<ILocale>>(
      `${this.baseUrl}/public/languages?page=0&size=50`
    );
  }

  triggerLanguageChange() {
    this.languageChangedSubject.next(true);
  }

  resetTrigger() {
    this.languageChangedSubject.next(false);
  }

  setSupportedLocales(locales: ILocale[]) {
    this.supportedLocalesSubject.next(locales);
  }

  setActiveLocale(locale: ILocale) {
    this.activeLocaleSubject.next(locale);
  }
}
